import { Box } from "@mui/material";
import { FrequencyBands } from "../protocol/FrequencyBands";
import { ElectrodeLocations } from "../protocol/ElectrodeLocations";
import { DateField } from "../../../../components/fieldsViews/fields/DateField";

type NeurofeedbackProtocolGridFieldProps = {
    value: any;
};

export const NeurofeedbackProtocolGridField = ({ value }: NeurofeedbackProtocolGridFieldProps) => {
    const frequencyBands = value.protocol?.frequency_bands;
    const electrodesLocations = value.protocol?.electrodes_locations;


    console.log("protocol", value.protocol?.date_created);
    return (
        <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
           <DateField value={value.protocol?.date_created} fieldView="group" />
            <ElectrodeLocations electrodesLocations={electrodesLocations} />
            <FrequencyBands frequencyBands={frequencyBands} />
        </Box>
    );
};
